<template>
  <v-container>
    <v-card id="repair-details">
<!--      <v-breadcrumbs :items="quote.versions">
         <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        :href="item"
      >
        {{ item.toUpperCase() }}
      </v-breadcrumbs-item>
      </template>
      </v-breadcrumbs>
-->
      <v-card-title> Στοιχεία Επισκευής </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          :valid="valid"
        >
        <v-row>
          <v-col cols=2 sm=2 md=2>
          <v-text-field
          label="Αρ. Επισκευής"
          v-model="repair.Id"
          prepend-icon="mdi-counter"
            >
          </v-text-field>
          </v-col>
          <v-col cols=12 sm=4 md=3>
                <v-text-field
                  v-model="repair.Date"
                  label="Ημερομηνία"
                  prepend-icon="mdi-calendar"
                  readonly
                ></v-text-field>
          </v-col>
            <v-col cols=12 sm=4 md=3>
          <v-text-field
            v-model="repair.Vehicle.PlateNumber"
            :prepend-icon="$vehicleBadges[repair.Vehicle.VehType]"
            readonly
            label="Όχημα"
            >
             <template v-slot:append>
              <v-btn icon @click="vehicleDetails"><v-icon>mdi-information</v-icon></v-btn>
            </template>
          </v-text-field>
          </v-col>
          <v-col cols=3 md=3>
          <v-text-field
            v-model="repair.Odometer"
            prepend-icon="mdi-counter"
            label="Ενδ. Ταχογράφου"
            suffix="χιλιόμετρα"
            >
            </v-text-field>

            </v-col>

        </v-row>
         <v-row>
          <v-col cols=12 md=6>
          <v-text-field
            v-model="repair.Vehicle.Owner.Name"
            prepend-icon="mdi-account"
            readonly
            label="Πελάτης"
            >
            <template v-slot:append>
              <v-btn icon @click="accountPage"><v-icon>mdi-information</v-icon></v-btn>
            </template>
            </v-text-field>

            </v-col>
        </v-row>
          <v-row>
          <v-col cols=12 md=6>
          <v-textarea
            v-model="repair.Notes"
            prepend-icon="mdi-notebook"
            rows="1"
            :auto-grow=true
            label="Σημειώσεις"
            hint="Αριθμός πλαισίου, όχημα, κλπ"
            >
         </v-textarea>
          </v-col>
          </v-row>
          <v-row>
          <v-btn
            v-model="repair.Id"
            outlined
            dark
            color="primary"
            class="ml-2 white--text"
            :to="{name: 'edit-repair', params: {repairId: repair.Id}}"
            >
            <v-icon>mdi-car-wrench</v-icon>Επισκεύη
          </v-btn>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>

      <v-speed-dial
      v-model="fab2"
      right
      bottom
      absolute
      direction="left"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab2"
          color="blue-grey darken-1"
          dark
          fab
        >
          <v-icon v-if="fab2">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-file-pdf-box
          </v-icon>
        </v-btn>
      </template>
             <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="getPDF"
              >
              <v-icon dark>mdi-file-pdf-box</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="getPDFWOP"
              >
              <v-icon dark>mdi-card-bulleted-outline</v-icon>
            </v-btn>
             <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="getPDFBlack"
              >
              <v-icon dark>mdi-card-bulleted</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="getPDFCODE39"
              >
              <v-icon dark>mdi-qrcode</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="getServiceLabel"
              >
              <v-icon dark>mdi-sticker</v-icon>
            </v-btn>
             <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="send">
              <v-icon dark>mdi-send</v-icon>
            </v-btn>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="duplicateQuote">
              <v-icon dark>mdi-content-copy</v-icon>
            </v-btn>
             <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="convertToQuote">
              <v-icon dark>mdi-file-swap</v-icon>
            </v-btn>
        </v-speed-dial>
      <v-speed-dial
      v-model="fab"
      top
      right
      direction="left"
      absolute
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="blue-grey darken-1"
          dark
          fab
        >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="updateNotes">
              <v-icon dark>mdi-content-save</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="getDCL"
              >
              <v-icon dark>mdi-book</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="dialogHistParts = true"
              >
              <v-icon dark>mdi-history</v-icon>
            </v-btn>
        </v-speed-dial>
      </v-card-actions>
    </v-card>

    <v-card class="mx-auto mt-10" id="item-list" >
      <v-card-title>Λίστα Παραγγελιών
       <v-btn
            color="blue darken-1"
            icon
            @click="getRepair"
          >
          <v-icon>mdi-refresh</v-icon>
          </v-btn>
      </v-card-title>
      <v-card-text >
    <v-expansion-panels v-if="isAdmin" elevation=0 class="my-2 py-4" accordion>
      <v-expansion-panel>
        <v-expansion-panel-header>Πληροφορίες
        </v-expansion-panel-header>
        <v-expansion-panel-content>

        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>


      <v-data-table
        :headers="showHeaders"
        :items="preorderItems"
        item-key="itemId"
        :search="search"
        :item-class="rowClass"
        class="elevation-0"
        height="600px"
        mobile-breakpoint=800
        dense
        show-group-by
        show-select
        @item-selected="itemSelected"
        @toggle-select-all="itemSelectAll"
        fixed-header>

        <v-divider inset></v-divider>
        <template v-slot:top>
          <v-toolbar flat height="120px" color="white">
            <div class="d-flex w-400">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" dense outlined single-line hide-details></v-text-field>
            <v-dialog
                v-model="dialog"
                persistent
                max-width="700px"
              >
                <template v-slot:activator="{on, attrs}">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2 white--text">
                      <v-icon dark>mdi-cart-plus</v-icon>
                    </v-btn>
                </template>
                <v-card>
                  <v-card-title class="d-flex align-center">
                    <v-icon class="mr-2">mdi-cart-plus</v-icon>
                    {{ formTitle }}
                    <v-spacer />
                    <!-- <v-chip small v-if="editedItem && editedItem.SupplierId">
                      {{ (suppliers || []).find(s=>s.Id===editedItem.SupplierId)?.Name || '—' }}
                    </v-chip> -->
                  </v-card-title>
                  <v-divider />
                  <v-card-text>
                    <v-form ref="repair">
                      <v-container fluid>
                        <v-row dense>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              label="Κωδ. Κατασκευαστή"
                              :rules="[rules.required]"
                              v-model="editedItem.ManufacturerSku"
                              hide-details="auto"
                            />
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              label="Κωδ. Προμηθευτή"
                              v-model="editedItem.SupplierSku"
                              hide-details="auto"
                            />
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                          <v-combobox
                            label="Κατασκευαστής"
                            :items="manufacturers"
                            v-model="editedItem.Manufacturer"
                            ></v-combobox>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-autocomplete
                              v-model="editedItem.PartId"
                              :loading="loading"
                              :items="parts"
                              :search-input.sync="searchParts"
                              hide-details
                              placeholder="Αναζήτηση με # για SKU, @ για αντιστοιχίες. * για wildcard."
                              item-text='Description'
                              item-value='Id'
                              no-filter
                              :hint="`${select.FmSku} ${select.Id}`"
                              persistent-hint
                              label="Ανταλλακτικό"
                            >
                              <template v-slot:selection="data">
                                {{ data.item.Id }}: {{ data.item.FmSku }} - {{ data.item.Description }}
                              </template>
                              <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                  <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                                <template v-else>
                                  <v-list-item-content>
                                    <v-list-item-title v-html="data.item.FmSku"></v-list-item-title>
                                    <v-list-item-subtitle v-html="data.item.Description"></v-list-item-subtitle>
                                    <v-list-item-subtitle v-html="data.item.matchReason"></v-list-item-subtitle>
                                  </v-list-item-content>
                                </template>
                              </template>
                              <template v-slot:no-data>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      Δεν βρέθηκαν αποτελέσματα. Δοκιμάστε:
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                      <v-btn text @click="prependPrefix('#')"># για SKU</v-btn>
                                      <v-btn text @click="prependPrefix('@')">@ για αντιστοιχίες</v-btn>
                                      <v-btn text @click="prependPrefix('!')">! για Order ID</v-btn>
                                      <v-btn icon @click="clearOrder(0)"><v-icon>mdi-trash-can</v-icon></v-btn>
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              label="Σχόλια"
                              v-model="editedItem.Remarks"
                              hide-details="auto"
                            />
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6" sm="4" md="3">
                            <v-text-field
                              label="Ποσότητα"
                              :rules="[rules.required]"
                              v-model.number="editedItem.Qty"
                              type="number"
                              hide-details="auto"
                            />
                          </v-col>
                          <v-col v-if="isAdmin" cols="6" sm="4" md="3">
                            <v-text-field
                              label="Τιμή"
                              type="number"
                              :rules="[rules.required]"
                              v-model.number="editedItem.Price"
                              persistent-hint
                              hide-details="auto"
                            >
                              <template v-slot:append>
                                <v-btn icon v-if="editedItem.Kind==0" @click="showHistory(editedItem)" color="primary">
                                  <v-icon>mdi-history</v-icon>
                                </v-btn>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="6" sm="4" md="3">
                            <v-select
                              label="Μονάδα Μέτρησης"
                              v-model="editedItem.Unit"
                              :items="['ΤΕΜ', 'ΣΕΤ', 'ΚΙΛΑ', 'ΛΙΤΡΑ', 'ΜΕΤΡΟ', 'ΩΡΑ','ΚΥΒΙΚΑ', '']"
                              hide-details
                            />
                          </v-col>
                          <v-col cols="6" sm="4" md="3">
                            <v-select
                              label="Κατάσταση"
                              :rules="[rules.required]"
                              v-model="editedItem.Status"
                              :items="statuses"
                              hide-details
                            />
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <v-autocomplete
                              label="Προμηθευτής"
                              v-model="editedItem.SupplierId"
                              :items="suppliers"
                              hide-details
                              item-text="Name"
                              item-value="Id"
                            />
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-select
                              label="Τεχνικός"
                              :rules="[rules.required]"
                              v-model="editedItem.TechId"
                              :items="technicians"
                              item-text="Name"
                              item-value="Id"
                              hide-details
                            />
                          </v-col>
                        </v-row>

                        <v-row dense v-if="isAdmin">
                          <v-col cols="12" class="grey--text text--darken-1 caption">
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
                  <v-divider />
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialog = false"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                    >
                      Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-btn
                color="primary"
                class="ml-2 white--text"
                :disabled="(receivedCount === 0 && selectedCheckoutCount === 0)" 
                @click="checkoutReceivedPreorders"
              >
                <v-icon left>mdi-clipboard-check</v-icon>
                 {{ selectedCheckoutCount ? `Χρέωση επιλεγμένων (${selectedCheckoutCount})` : `Χρέωση παραληφθέντων (${receivedCount})` }}
              </v-btn>
              <v-btn
                color="primary"
                class="ml-2 white--text"
                :loading="csvProcessing"
                @click="onCsvPick"
              >
                <v-icon left>mdi-file-upload</v-icon>Μεταφόρτωση CSV
              </v-btn>
              <input
                ref="csvInput"
                type="file"
                accept=".csv,text/csv"
                style="display:none"
                @change="onCsvSelected"
              />

              <!-- CSV Preview Dialog -->
              <v-dialog v-model="csvPreviewDialog" max-width="1100px" persistent>
                <v-card>
                  <v-card-title class="d-flex align-center">
                    <v-icon class="mr-2">mdi-file-table</v-icon>
                    Προεπισκόπηση CSV προπαραγγελιών
                    <v-spacer />
                    <v-chip small>{{ csvRows.length }} γραμμές</v-chip>
                  </v-card-title>
                  <v-divider />
                  <v-card-text>
                    <v-data-table
                      :headers="csvPreviewHeaders"
                      :items="csvRows"
                      item-key="__rowId"
                      show-select
                      v-model="csvSelected"
                      dense
                      class="elevation-1"
                      :footer-props="{ itemsPerPageOptions: [5,10,20,50] }"
                    >
                      <template v-slot:item.Price="{ item }">
                        {{ tocurr(item.Price || 0) }}
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <v-btn icon small @click="openCsvEdit(item)">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card-text>
                  <v-divider />
                  <v-card-actions>
                    <v-spacer />
                    <v-btn text color="grey" @click="closeCsvPreview">Κλείσιμο</v-btn>
                    <v-btn
                      color="primary"
                      class="white--text"
                      :disabled="!csvSelected.length || csvProcessing"
                      :loading="csvProcessing"
                      @click="submitSelectedCsv"
                    >
                      <v-icon left>mdi-check</v-icon>Υποβολή επιλεγμένων ({{ csvSelected.length }})
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- Inline Edit Dialog for CSV Row -->
              <v-dialog v-model="csvEditDialog" v-if="csvEditItem" max-width="700px">
                <v-card>
                  <v-card-title class="d-flex align-center">
                    <v-icon class="mr-2">mdi-pencil</v-icon>
                    Επεξεργασία γραμμής
                  </v-card-title>
                  <v-divider />
                  <v-card-text>
                    <v-form ref="csvEditForm">
                      <v-container fluid>
                        <v-row dense>
                          <v-col cols="12" sm="6">
                            <v-text-field label="Κωδ. Κατασκευαστή" v-model="csvEditItem.ManufacturerSku" />
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field label="Κωδ. Προμηθευτή" v-model="csvEditItem.SupplierSku" />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" sm="6">
                            <v-text-field label="Κατασκευαστής" v-model="csvEditItem.Manufacturer" />
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-autocomplete
                              v-model="csvEditItem.PartId"
                              :loading="loading"
                              :items="parts"
                              :search-input.sync="searchParts"
                              hide-details
                              placeholder="Αναζήτηση με # για SKU, @ για αντιστοιχίες. * για wildcard."
                              item-text='Description'
                              item-value='Id'
                              no-filter
                              :hint="`${select.FmSku} ${select.Id}`"
                              persistent-hint
                              label="Ανταλλακτικό"
                            >
                              <template v-slot:selection="data">
                                {{ data.item.Id }}: {{ data.item.FmSku }} - {{ data.item.Description }}
                              </template>
                              <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                  <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                                <template v-else>
                                  <v-list-item-content>
                                    <v-list-item-title v-html="data.item.FmSku"></v-list-item-title>
                                    <v-list-item-subtitle v-html="data.item.Description"></v-list-item-subtitle>
                                    <v-list-item-subtitle v-html="data.item.matchReason"></v-list-item-subtitle>
                                  </v-list-item-content>
                                </template>
                              </template>
                              <template v-slot:no-data>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      Δεν βρέθηκαν αποτελέσματα. Δοκιμάστε:
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                      <v-btn text @click="prependPrefix('#')"># για SKU</v-btn>
                                      <v-btn text @click="prependPrefix('@')">@ για αντιστοιχίες</v-btn>
                                      <v-btn text @click="prependPrefix('!')">! για Order ID</v-btn>
                                      <v-btn icon @click="clearOrder(0)"><v-icon>mdi-trash-can</v-icon></v-btn>
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12">
                            <v-text-field label="Σχόλια" v-model="csvEditItem.Remarks" />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="6" sm="4">
                            <v-text-field label="Ποσότητα" v-model.number="csvEditItem.Qty" type="number" />
                          </v-col>
                          <v-col cols="6" sm="4">
                            <v-text-field label="Μονάδα" v-model="csvEditItem.Unit" />
                          </v-col>
                          <v-col cols="12" sm="4">
                            <v-text-field label="Τιμή" v-model.number="csvEditItem.Price" type="number" />
                          </v-col>
                          <v-col cols="12" sm="4">
                            <v-text-field label="Τιμή αγοράς" disabled="True" v-model.number="csvEditItem.NetPrice"/>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="6" sm="4">
                            <v-select
                              :items="statuses"
                              item-text="text"
                              item-value="value"
                              label="Κατάσταση"
                              v-model="csvEditItem.Status"
                            />
                          </v-col>
                          <v-col cols="6" sm="4">
                            <v-select
                              :items="technicians"
                              item-text="Name"
                              item-value="Id"
                              label="Τεχνικός"
                              v-model="csvEditItem.TechId"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn text color="grey" @click="csvEditDialog=false">Άκυρο</v-btn>
                    <v-btn color="primary" class="white--text" @click="applyCsvEdit">
                      <v-icon left>mdi-content-save</v-icon>Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

               <v-dialog
                v-model="dialog3"
                persistent
                max-width="800px"
              >
                <template v-slot:activator="{on, attrs}">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2 white--text">
                      <v-icon dark>mdi-package-variant</v-icon>
                    </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Εισαγωγη Ανταλλακτικού</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="invoice">
                    <v-container>
                      <v-row>

                      <v-col cols="4" sm="4" md=4>
                          <v-text-field
                            label="Ποσότητα*"
                            :rules="[rules.required, rules.qty]"
                            v-model.number="partQty"
                            required
                            :hint="hintQty"
                            persistent-hint
                            ></v-text-field>

                      </v-col>
                       <v-col cols="12" sm="8" md=6>
                       <v-autocomplete
                          v-model="order"
                          :items="partsFiltered"
                          return-object
                          :hint="`${order.SupplierSku} - ${order.FmSku}`"
                          persistent-hint
                          no-filter
                          :search-input.sync="searchParts"
                          @update:search-input="updateSearchInput"
                          :prepend-icon="prefixIcon"
                          label="Ανταλλακτικό"
                          placeholder="Αναζήτηση με # για SKU, @ για αντιστοιχίες. * για wildcard."
                        >
                          <template v-slot:selection="data">
                              {{ data.item.SupplierSku }} - {{ data.item.ManufacturerSku }} - {{ data.item.Description }}
                          </template>
                          <template v-slot:item="{ item }">
                            <template v-if="typeof item !== 'object'">
                              <v-list-item-content v-text="item"></v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-content>
                                <v-list-item-title>{{ item.ManufacturerSku }} - Παρτίδα {{ item.Id }} ({{ item.Timestamp.slice(0,10) }})</v-list-item-title>
                                <v-list-item-subtitle>Απόθεμα {{ item.StockQty }} {{ item.Unit }} </v-list-item-subtitle>
                                <v-list-item-subtitle>{{ item.FmSku }} (#{{ item.PartId }}) - {{ item.Description }} {{ item.Remarks }} </v-list-item-subtitle>
                                <v-list-item-subtitle>Τιμή: {{ tocurr(item.SuggestedPrice) }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </template>
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>
                                  Δεν βρέθηκαν αποτελέσματα. Δοκιμάστε:
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  <v-btn text @click="prependPrefix('#')"># για SKU</v-btn>
                                  <v-btn text @click="prependPrefix('@')">@ για αντιστοιχίες</v-btn>
                                  <v-btn text @click="prependPrefix('!')">! για Order ID</v-btn>
                                  <v-btn icon @click="clearOrder(0)"><v-icon>mdi-trash-can</v-icon></v-btn>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                          <template v-slot:prepend-item>
                            <v-list-item v-if="searchParts">
                              <v-list-item-content>
                                <v-list-item-title>
                                  Αλλαγή τύπου αναζήτησης:
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  <v-btn text @click="prependPrefix('#')"># για SKU</v-btn>
                                  <v-btn text @click="prependPrefix('@')">@ για αντιστοιχίες</v-btn>
                                  <v-btn text @click="prependPrefix('!')">! για Order ID</v-btn>
                                  <v-btn icon @click="clearOrder(1)"><v-icon>mdi-trash-can</v-icon></v-btn>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                        </v-col>
                        <v-col cols="auto">
                          <v-btn @click="getParts()" icon>
                            <v-icon>mdi-refresh</v-icon>
                          </v-btn>
                        </v-col>
                        <v-col cols="6" sm="6" md=4>
                          <v-select
                            label="Τεχνικός"
                            :rules="[rules.required]"
                            v-model="partTechId"
                            :items="technicians"
                            item-text="Name"
                            item-value="Id"
                            dense single-line
                            required
                            ></v-select>
                      </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialog3 = false"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="savePart"
                    >
                      Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              </div>


              <v-spacer/>
               <v-col
                  class="py-0"
                >
                  <v-btn-toggle
                    v-model="showServicesOnly"
                    background-color="white"
                    color="blue lighten-2"
                    multiple
                    mandatory
                  >
                    <v-btn>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" >
                            <v-icon v-if="showServicesOnly.includes(0)">mdi-package-variant</v-icon>
                            <v-icon v-else>mdi-package-variant-closed</v-icon>
                          </span>
                        </template>
                        <span>Ανταλλακτικά: {{ tocurr(netItems) }}</span>
                      </v-tooltip>
                      </v-btn>
                    <v-btn>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" >
                            <v-icon v-if="showServicesOnly.includes(1)">mdi-account-wrench</v-icon>
                            <v-icon v-else>mdi-account</v-icon>
                          </span>
                        </template>
                        <span>Εργασία: {{ tocurr(netService) }}</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" >
                            <v-icon v-if="showServicesOnly.includes(2)">mdi-package-variant-plus</v-icon>
                            <v-icon v-else>mdi-package-variant-closed-plus</v-icon>
                          </span>
                        </template>
                        <span>Έξτρα: {{ tocurr(netAddons) }}</span>
                      </v-tooltip>
                    </v-btn>

                  </v-btn-toggle>
                </v-col>
        <div v-if="isAdmin" class="text-right pa-10 ma-0">
        </div>
            </v-toolbar>
          </template>

        <template v-slot:item.index="{ item }">
          <span>{{repairItems.indexOf(item)+1}}</span>
        </template>
        <template v-slot:item.Status="{ item }">
          <span>{{ getStatus(item.Status) }}</span>
        </template>

        <template v-slot:item.TechId="{ item }">
          <span>{{ technicians[item.TechId-1].Name }}</span>
        </template>
         <template v-slot:item.Sku="{ item }">
          <span v-if="item.CheckoutPart">
            <v-btn icon :to="{name: 'order-info', params: {id: item.CheckoutPart}}">
            <v-icon plain color="teal darken-2" v-if="item.Kind==2" >mdi-tag-plus</v-icon>
            <v-icon plain color="teal darken-2" v-else >mdi-package-variant-closed</v-icon>
            </v-btn>
            </span>
            <span v-if="!item.CheckoutPart">
            <v-icon class="mx-2 px-0" v-if="item.Kind==1">mdi-account-wrench</v-icon>
            <v-icon class="mx-2 px-0" v-else-if="item.Kind==2">mdi-tag-plus</v-icon>
            <v-icon class="mx-2 px-0" v-else>mdi-package-variant-closed</v-icon>
            </span>
            <span>{{ item.Sku }}</span>
        </template>
        <template v-slot:item.Price="{ item }">
            <span v-if="isNaN(item.Price)">{{ tocurr(0) }}</span>
            <span v-else>{{ tocurr(item.Price) }}</span>
        </template>


        <template v-slot:item.actions="{ item }">
          <div>
            <v-icon class="mr-3" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <!-- <v-icon class="mr-3" @click="copyItem(item)">
              mdi-content-copy
            </v-icon> -->
            <v-icon @click="deleteItem(item)">
              mdi-delete
            </v-icon>
            <v-icon class="ml-3" @click="openView(item)">
              mdi-eye
            </v-icon>
          </div>
        </template>

        <template
        v-slot:group.header="{ group, groupBy, items, isOpen, toggle, remove }"
      >
        <th colspan="10">
          <v-icon @click="toggle"
            >{{ isOpen ? "mdi-minus" : "mdi-plus" }}
          </v-icon>
         <v-span  v-if="groupBy=='Sku'" round color="primary">Κωδικός: {{ group }} </v-span>
         <v-chip  v-else color="primary">{{ group }}</v-chip>
          <v-chip round color="light-blue darken-4" text-color="white">Ποσότητα: {{ $sumField(items, "Qty") }}</v-chip>
          <v-chip round color="light-blue darken-4" text-color="white">Κοστος: {{ $tocurr(sumTotals(items)) }}</v-chip>
          <v-icon @click="remove">mdi-close </v-icon>
        </th>
   </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      </v-card-text>
      <v-card-actions >
      </v-card-actions>
    </v-card>
   <v-snackbar
   timeout=2500
   v-model="snackbar">
      {{ snackText }}
  </v-snackbar>

   <v-dialog
      v-model="dialogHist"
      width="auto"
    >
      <v-card>
       <v-card-title> Προηγούμενες χρεώσεις </v-card-title>
        <v-card-text>
        <v-container>
           <v-data-table
        :headers="chargesHeader"
        :loading="loading"
        :items="charges"
        :item-class="rowClass"
        class="elevation-0"
        height="400px"
        mobile-breakpoint=800
        :items-per-page=5
        fixed-header>
         <template v-slot:item.Timestamp="{ item }">
       {{  new Date(item.Timestamp).toLocaleDateString()  }}
    </template>

    <template v-slot:item.actions="{ item }">
             <v-btn
              class="mr-2"
              icon
              small
            :to="{name: 'edit-repair', params: {repairId: item.RepairId}, target: '_blank'}"
            >
              <v-icon>mdi-car-wrench</v-icon>
            </v-btn>
                </template>
        </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="dialogHist = false">Κλεισιμο</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="viewDialog"
      max-width="720px"
    >
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2">mdi-eye</v-icon>
          Πληροφορίες Προπαραγγελίας
          <v-spacer></v-spacer>
          <v-chip v-if="selectedPreorder" :color="statusColor(selectedPreorder.Status)" dark small>
            {{ getStatus(selectedPreorder.Status) }}
          </v-chip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container v-if="selectedPreorder" fluid>
            <v-row dense>
              <v-col cols="12" class="d-flex align-center justify-space-between">
                <div class="text-subtitle-2 font-weight-medium">
                  {{ (selectedPreorder.PartInfo && selectedPreorder.PartInfo.Description) || selectedPreorder.Description || '-' }}
                </div>
                <div>
                  <v-btn icon small :to="{ name: 'part-info', params: { id: selectedPreorder.PartId } }" :disabled="!selectedPreorder.PartId">
                    <v-icon>mdi-information-outline</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6">
                <div class="grey--text text--darken-1 caption">Αρ. Προπαραγγελίας</div>
                <div class="text-body-2">{{ selectedPreorder.Id || '-' }}</div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="grey--text text--darken-1 caption">Ημ/νία</div>
                <div class="text-body-2">{{ selectedPreorder.Timestamp ? new Date(selectedPreorder.Timestamp).toLocaleString() : '-' }}</div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" class="d-flex align-start">
                <div class="flex-grow-1">
                  <div class="grey--text text--darken-1 caption">Προμηθευτής</div>
                  <div class="text-body-2">{{ (selectedPreorder.Supplier && selectedPreorder.Supplier.Name) || '-' }}</div>
                  <div class="text-caption grey--text" v-if="selectedPreorder.Supplier && selectedPreorder.Supplier.Telephone">
                    <v-icon x-small class="mr-1">mdi-phone</v-icon>{{ selectedPreorder.Supplier.Telephone }}
                  </div>
                </div>
                <div>
                  <v-btn icon small :to="{ name: 'distributor-preorders', params: { id: (selectedPreorder.Supplier && selectedPreorder.Supplier.Id) || selectedPreorder.SupplierId } }" :disabled="!( (selectedPreorder.Supplier && selectedPreorder.Supplier.Id) || selectedPreorder.SupplierId )">
                    <v-icon>mdi-truck</v-icon>
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="d-flex align-start">
                <div class="flex-grow-1">
                  <div class="grey--text text--darken-1 caption">Τεχνικός</div>
                  <div class="text-body-2">{{ (selectedPreorder.User && selectedPreorder.User.Name) || (technicians[selectedPreorder.TechId-1] && technicians[selectedPreorder.TechId-1].Name) || '-' }}</div>
                </div>
                <div>
                  <v-btn icon small :to="{ name: 'order-info', params: { id: selectedPreorder.CheckinId } }" :disabled="!selectedPreorder.CheckinId">
                    <v-icon>mdi-clipboard-check</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6">
                <div class="grey--text text--darken-1 caption">Κωδικός Προμηθευτή</div>
                <div class="text-body-2">{{ selectedPreorder.SupplierSku || '-' }}</div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="grey--text text--darken-1 caption">Κωδικός Κατασκευαστή</div>
                <div class="text-body-2">{{ selectedPreorder.ManufacturerSku || '-' }}</div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6">
                <div class="grey--text text--darken-1 caption">Ποσότητα</div>
                <div class="text-body-2">{{ selectedPreorder.Qty || 0 }} {{ selectedPreorder.Unit || '' }}</div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="grey--text text--darken-1 caption">Τιμή</div>
                <div class="text-body-2">{{ tocurr(selectedPreorder.Price || 0) }}</div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <div class="grey--text text--darken-1 caption">Σχόλια</div>
                <div class="text-body-2">{{ selectedPreorder.Remarks || '-' }}</div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" class="d-flex align-center">
                <div class="grey--text text--darken-1 caption mr-2">Part ID</div>
                <div class="text-body-2 mr-2">{{ selectedPreorder.PartId || '-' }}</div>
                <v-btn icon x-small :to="{ name: 'part-info', params: { id: selectedPreorder.PartId } }" :disabled="!selectedPreorder.PartId">
                  <v-icon small>mdi-open-in-new</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="grey--text text--darken-1 caption">Repair ID</div>
                <div class="text-body-2">{{ selectedPreorder.RepairId || '-' }}</div>
              </v-col>
            </v-row>
            <v-expansion-panels flat class="mt-2">
              <v-expansion-panel>
                <v-expansion-panel-header>Πλήρη δεδομένα</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <pre class="text-body-2" style="white-space: pre-wrap;">{{ JSON.stringify(selectedPreorder, null, 2) }}</pre>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
          <div v-else class="text-center grey--text">Δεν υπάρχει διαθέσιμη πληροφορία.</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="viewDialog = false">Κλείσιμο</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogHistParts"
      width="auto"
    >
      <v-card>
       <v-card-title> Προηγούμενες χρεώσεις Ανταλλακτικών </v-card-title>
        <v-card-text>
        <v-container>
         <v-text-field v-model="historySearch"
          append-icon="mdi-magnify"
          label="Search"
          dense
          outlined
          single-line
          hide-details
          ></v-text-field>
        <v-data-table
        :headers="histPartsHeader"
        :loading="loading"
        :items="histParts"
        :item-class="rowClass"
        :search="historySearch"
        class="elevation-0"
        height="400px"
        mobile-breakpoint=800
        :items-per-page=5
        fixed-header>
         <template v-slot:item.Timestamp="{ item }">
       {{  new Date(item.Timestamp).toLocaleDateString()  }}
    </template>

    <template v-slot:item.actions="{ item }">
      <v-btn
        class="mr-2"
        icon
        small
        @click="copyHistPartToPreorder(item)"
        :title="'Δημιουργία προπαραγγελίας από τη γραμμή'"
      >
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
             <v-btn
              class="mr-2"
              icon
              small
            :to="{name: 'edit-repair', params: {repairId: item.RepairId}, target: '_blank'}"
            >
              <v-icon>mdi-car-wrench</v-icon>
            </v-btn>
            <v-btn
              v-if="item.PartId"
              class="mr-2"
              icon
              small
            :to="{name: 'part-orders', params: {id: item.PartId}, target: '_blank'}"
            >
              <v-icon>mdi-package-variant-closed</v-icon>
            </v-btn>
                </template>
        </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="dialogHistParts = false">Κλεισιμο</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
  
<script>
//const _ = require("lodash");

// import filter from "lodash/filter";

export default {
  components: {
  },
  watch: {
    orderSearch(val) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.fetchPartsFilter(val);
      }, 250); // Adjust the delay as needed
    },
    searchParts(val) {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
        this.fetchFilteredParts(val);
        }, 300); // Adjust the delay as needed
    },
  },
  computed: {
    canPatchSelected() {
      return !!(this.correlateSourceItem && this.correlateSourceItem.CheckinId);
    },
    hintQty () {
      return `Διαθέσιμα: ${this.order.StockQty}`
    },
    hintLimit () {
      return `Τιμή > ${this.editedItem.Limit}`
    },
    collectionItems() {
      return this.repairItems.filter(e=>e.Status == -1 && e.CheckoutPart)
    },
    net () {
      return this.sumTotals(this.repairItems.filter(e=>e.Status !=-1));
    },
    netServiceRatio () {
      return (this.netParts * (this.partServiceEnabled ? (1 - this.partServiceRatio / 100) : 1)) + (this.netService + this.partDiscount)
    },
    netItems () {
      return this.sumTotals(this.repairItems.filter(e=>e.Status !=-1).filter(e=>e.Kind==0));
    },
    netParts () {
      return this.sumTotals(this.repairItems.filter(e=>e.Status !=-1).filter(e=>e.Kind!=1));
    },
    netService () {
      return this.sumTotals(this.repairItems.filter(e=>e.Status !=-1).filter(e=>e.Kind==1));
    },
    netAddons () {
      return this.sumTotals(this.repairItems.filter(e=>e.Status !=-1).filter(e=>e.Kind==2));
    },
    vat () {
      return Number(this.net) * 0.24;
    },
    total () {
      return Number(this.net) + Number(this.vat);
    },
    partProfit () {
      return this.sumProfit(this.repairItems.filter(e=>e.Status !=-1 & e.Kind != 1));
    },
    partCost () {
      return this.sumCost(this.repairItems.filter(e=>e.Status !=-1 & e.Kind != 1));
    },
    serviceCost () {
      return this.sumService(this.repairItems.filter(e=>e.Kind == 1));
    },
    invoicedProfit () {
          return this.sumProfit(this.repairItems.filter(e=>e.Status == 0 & e.Kind != 1));
    },
    profit () {
      return this.sumProfit(this.repairItems.filter(e=>e.Status !=-1));
    },
    pdfPath () {
        return `${this.$api.defaults.baseURL}/repairs/${this.repair.Id}/card/`;
    },
    selectedCheckoutCount() { return (this.selectedRows || []).filter(i => i.Status === 0 && i.CheckinId).length; },
    preorderItems() {
      return this.repairItems.map(x => ({ ...x, isSelectable: x.Status == 0 }));
    },
    showHeaders() {
         const profitColumn = {
        text: 'Κέρδος',
        value: 'profit',
        sortable: false,
        groupable: false,
      };
      let headers = [];
      let baseheaders = [];
      const headersToExclude = ["Status", "TechId"];

      if (!this.isAdmin) {
        headers.push("Price");
      }
      if (this.$vuetify.breakpoint.smAndDown) {

        headers.push(headersToExclude)
        baseheaders = this.headers.filter(h => !headers.includes(h.value));
      } else {
        baseheaders = this.headers.filter(h => !headers.includes(h.value));
      }
        return this.showProfit
      ? [...baseheaders, profitColumn]
      : baseheaders;
    },
    repairItemsF() {
      return this.repairItems;
    },
    repairParts() {
      return this.repairItems.filter(e => e.Kind == 0 );
    },
    repairAddons() {
      return this.repairItems.filter(e => e.Kind == 2 );
    },
    formTitle () {
        return this.editedIndex === -1 ? 'Νέα παραγγελία' : 'Επεξεργασία παραγγελίας'
    },
    isAdmin() {
        if (!this.$store.state.authentication.user) return false;
        return this.$store.state.authentication.user.scopes.includes("income");
    },
    manufacturers() {
      return this.$manufacturers.map(e=>e.title);
    },
    receivedCount() {
      return (this.repairItems || []).filter(i => i.Status === 0 && i.CheckinId).length;
    },
    csvPreviewHeaders() {
      return [
        { text: 'Κ/Κατασκ.', value: 'ManufacturerSku' },
        { text: 'Κ/Προμηθευτή', value: 'SupplierSku' },
        { text: 'Κατασκευαστής', value: 'Manufacturer' },
        { text: 'Σχόλια', value: 'Remarks' },
        { text: 'Ποσότητα', value: 'Qty' },
        { text: 'Μονάδα', value: 'Unit' },
        { text: 'Τιμή', value: 'Price' },
        { text: 'PartId', value: 'PartId' },
        { text: '', value: 'actions', sortable: false },
      ];
    },

  },

  data () {
    return {
    menu: false,
    showProfit: false,
    fab: false,
    fab2: false,
    snackbar: false,
    snackText: "",
    valid: true,
    dialog: false,
    dialog2: false,
    dialog3: false,
    dialogHist: false,
    dialogHistParts: false,
    viewDialog: false,
    selectedPreorder: null,
    loading: false,
    selectedItem: null,
    showServicesOnly: [0,1],
    repair: {},
    allParts: [],
    suppliers: null,
    searchParts: '',
    select: '',
    repairId: null,
    debounceTimeout: null,
    technicians: {},
    order: {StockQty:0},
    partQty: 1,
    partTechId: 1,
    parts: [],
    partsFiltered: [],
    histParts: [],
    charges: [],
    processingCheckout: false,
    selectedRows: [],
    rules: {
        required: value => !!value || 'Required.',
        qty: value => value <= this.order.StockQty || 'Out of stock!',
        limit: value => value <= this.editedItem.Limit || 'Τιμή κάτω του κόστους'

    },
    csvProcessing: false,
    csvPreviewDialog: false,
    csvRows: [],
    csvSelected: [],
    csvEditDialog: false,
    csvEditItem: null,
    search: '',
    orderSearch: '',
    prefixIcon: 'mdi-tag',
    historySearch: '',
    headers: [
      {
        text: 'A/A',
        value: 'index',
        sortable: false,
        width: '5%',
        groupable: false,
      },
      {
        text: 'Ημ/νία',
        value: 'Timestamp',
        sortable: false,
        width: '5%',
        groupable: false,
      },
      {
        text: 'Κωδικός',
        value: 'SupplierSku',
        sortable: true,
        width: '10%',
        groupable: true,
      },
      {
        text: 'Κωδικός Kατασκευαστή',
        value: 'ManufacturerSku',
        sortable: true,
        width: '10%',
        groupable: true,
      },
      {
        text: 'Περιγραφή',
        value: 'PartInfo.Description',
        sortable: false,
        groupable: false,
        width: '35%'
      },
      {
        text: 'Ποσότητα',
        value: 'Qty',
        sortable: false,
        groupable: false,
        width: '5%'
      },
      {
        text: 'Μονάδα',
        value: 'Unit',
        sortable: false,
        width: '8%'
      },
      {
        text: 'Τιμή',
        value: 'Price',
        sortable: false,
        groupable: false,
      },
      {
        text: 'Κατάσταση',
        value: 'Status',
        sortable: false,
        groupable: true,
      },
      {
        text: 'Τεχνικός',
        value: 'User.Name',
        sortable: false,
        groupable: false,
      },
      { text: 'Επεξεργασία', value: 'actions', groupable:false, sortable: false , width: "150px"},
    ],
    histPartsHeader: [
      {
        text: 'Ημ/νία',
        value: 'Timestamp',
        sortable: false,
        width: '5%',
        groupable: false,
      },
      {
        text: 'Κωδικός',
        value: 'Sku',
        sortable: false,
        width: '10%',
        groupable: true,
      },
      {
        text: 'Κωδικός',
        value: 'ManfSku',
        sortable: false,
        width: '10%',
        groupable: true,
      },
      {
        text: 'Κατασκευαστής',
        value: 'Manf',
        sortable: false,
        width: '10%',
        groupable: true,
      },
      {
        text: 'Περιγραφή',
        value: 'Description',
        sortable: false,
        groupable: false,
        width: '25%'
      },
      {
        text: 'Ποσότητα',
        value: 'Qty',
        sortable: false,
        groupable: false,
        width: '5%'
      },
      {
        text: 'Μονάδα',
        value: 'Unit',
        sortable: false,
        width: '8%'
      },
      {
        text: 'Τιμή',
        value: 'Price',
        sortable: true,
        groupable: false,
      },
      {
        text: 'Τεχνικός',
        value: 'Technician.Name',
        sortable: false
      },
      {
       text: 'Actions',
       value: 'actions',
       sortable: false,
       width: "150px",
       groupable: false
       },
    ],
    chargesHeader: [
      {
        text: 'Ημ/νία',
        value: 'Timestamp',
        sortable: false,
        width: '5%',
        groupable: false,
      },
      {
        text: 'Όχημα',
        value: 'PlateNumber',
        sortable: true,
        width: '10%',
        groupable: true,
      },
      {
        text: 'Κωδικός',
        value: 'Sku',
        sortable: false,
        width: '10%',
        groupable: true,
      },
      {
        text: 'Κατασκευαστής',
        value: 'Manf',
        sortable: false,
        width: '10%',
        groupable: true,
      },
      {
        text: 'Περιγραφή',
        value: 'Description',
        sortable: false,
        groupable: false,
        width: '25%'
      },
      {
        text: 'Ποσότητα',
        value: 'Qty',
        sortable: false,
        groupable: false,
        width: '5%'
      },
      {
        text: 'Μονάδα',
        value: 'Unit',
        sortable: false,
        width: '8%'
      },
      {
        text: 'Τιμή',
        value: 'Price',
        sortable: false,
        groupable: false,
      },
      {
        text: 'Τεχνικός',
        value: 'Tech',
        sortable: false
      },
      {
       text: 'Actions',
       value: 'actions',
       sortable: false,
       width: "150px",
       groupable: false
       },
    ],
    repairItems: [],
    statuses: [
      {value: -1, text: "Παραγγελία"},
      {value: 1, text: "Χρέωση"},
      {value: 0, text: "Παραλαβή"},
      {value: -2, text: "Ζήτηση" },
     ],
    editedIndex: -1,
    editedItem: {
      Id: 0,
      ManufacturerSku: null,
      Manufacturer: null,
      SupplierId: null,
      RepairId: this.$route.params.repairId, 
      Remarks: '',
      Qty: 1,
      Unit: 'ΤΕΜ',
      Price: 0,
      Status: -2,
      TechId: 1,
    },
    defaultItem: {
      Id: 0,
      PartId: 0,
      SupplierSku: null,
      ManufacturerSku: null,
      Manufacturer: null,
      SupplierId: null,
      RepairId: this.$route.params.repairId, 
      Remarks: '',
      Qty: 1,
      Unit: 'ΤΕΜ',
      Price: 0,
      Status: -2,
      TechId: 5,
    },

    }
  },
  async created () {
      this.initialize();
  },
 mounted() {

        this._keyListener = function(e) {
            if (e.key === "s" && (e.ctrlKey || e.metaKey)) {
                e.preventDefault(); // prevent "Save Page" from getting triggered.

                this.updateNotes();
            }
        };

        document.addEventListener('keydown', this._keyListener.bind(this));
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this._keyListener);
  },
  methods: {
   partServiceRatioUpdate(newValue) {
    console.log(newValue)
      if (newValue < 1) {
        this.partServiceEnabled = false;
        this.partDiscount = 0
      } else{
        this.partServiceEnabled = true;
        this.partDiscount = this.netParts * this.partServiceRatio/100

      }
    },
    roundToNearestTenOrFive(number) {
      console.log(number)
      const roundedNumber = Math.round(number / 5) * 5; // Round to the nearest multiple of 5
      if (roundedNumber % 10 === 5) {
        return roundedNumber; // Already rounded to the nearest multiple of 5
      } else if (roundedNumber % 10 > 5) {
        return Math.ceil(roundedNumber / 10) * 10; // Round up to the nearest multiple of 10
      } else {
        return Math.floor(roundedNumber / 10) * 10; // Round down to the nearest multiple of 10
      }
    },
   accountPage() {
        let path = "customer-info"
        let params = {"id": this.repair.Vehicle.Owner.Id}
        if (this.repair.Vehicle.Owner.Cid.startsWith("G")) {
              path = 'book-info';
        }

        this.$router.push({"name": path, "params": params});
    },
    vehicleDetails() {
        let path = "Vehicle"
        let params = {"vehicle": this.repair.VehId}
        this.$router.push({"name": path, "params": params});
    },
    getIcon(typeCode) {
      return typeCode === 102 ? 'mdi-package-variant-closed' : 'mdi-account-wrench';
    },
    getAadeIcon(typeCode) {
      return typeCode === '1.1' ? 'mdi-package-variant-closed' : 'mdi-account-wrench';
    },
    sumTotals(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b.Price*b.Qty || 0), 0);
    },
    sumProfit(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b.Profit*b.Qty || 0), 0);
    },

    sumCost(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b.NetCost*b.Qty || 0), 0);
    },

    sumService(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b.Price*b.Qty || 0), 0);
    },
    getStatus (status) {
      if (status == -2) return "Ζήτηση";
      if (status == -1) return "Παραγγελία";
      if (status == 1) return "Επισκευασμένο";
      if (status == 0) return "Παραλαβή";
    },
    statusColor (status) {
      if (status == -2) return 'orange darken-2';
      if (status == -1) return 'blue lighten-1';
      if (status == 0) return 'green darken-1';
      if (status == 1) return 'deep-purple darken-1';
      return 'grey';
    },
    openView (item) {
      this.selectedPreorder = item;
      this.viewDialog = true;
    },
    duplicateQuote () {
      return
    },
    async updateNotes () {
        await this.$api.patch("/repairs/"+this.$route.params.repairId, {Notes: this.repair.Notes, Odometer: this.repair.Odometer});
        this.snackText = `Αποθηκεύτηκε`;
          this.snackbar = true;
    },
    async invoice () {
        const response = await this.$api.patch("/repairs/invoice/"+this.$route.params.repairId);
        if (response.status == 202) {
              this.repair = response.data;
              this.repairItems = [];
              let j = 1;
              for (var value of this.repair.Items) {
                value.itemId = j;
                this.repairItems.push(value);
                j +=1;
              }
        }
    },
    async showHistory (item) {
        this.loading = true
        this.dialogHist = true
        let cid = this.repair.Vehicle.Owner.Id
        let non_billing = 0
        if (this.repair.Vehicle.Owner.Cid.startsWith("G"))
        {
            non_billing = 1
        }
        const response = await this.$api.get("/inventory/parts/charge-hist",{ params: {part_sku: item.Sku, customer_id: cid, 'non-billing': non_billing} });
        if (response.status == 200) {

              this.charges = response.data;
              //console.log(this.charges);
              }
        this.loading = false
    },
    async send () {
        const response = await this.$api.get("/repairs/send/"+this.$route.params.repairId);
        if (response.status == 200) {
            this.snackText = `Εστάλη επιτυχώς`;
            this.snackbar = true;
        } else {
            this.snackText = `Προέκυψε σφάλμα κατα την αποστολή. ${response.data.details}`;
            this.snackbar = true;
        }
    },
    async getPDF () {
        const response = await this.$api.get(`/repairs/${this.repair.Id}/card`);
        window.open(`${this.$api.defaults.baseURL}/repairs/card/${response.data}`, '_blank');
    },
     async getPDFWOP () {
        const response = await this.$api.get(`/repairs/${this.repair.Id}/cardnop`);
        window.open(`${this.$api.defaults.baseURL}/repairs/card/${response.data}`, '_blank');
    },
     async getPDFBlack () {
        const response = await this.$api.get(`/repairs/${this.repair.Id}/cardblack`);
        window.open(`${this.$api.defaults.baseURL}/repairs/card/${response.data}`, '_blank');
    },
     async getPDFCODE39 () {
        const response = await this.$api.get(`/repairs/${this.repair.Id}/code39`);
        window.open(`${this.$api.defaults.baseURL}/repairs/card/${response.data}`, '_blank');
    },
     async getDCL () {
        const response = await this.$api.get(`/repairs/${this.repair.Id}/dcl`);
        window.open(`${this.$api.defaults.baseURL}/repairs/card/${response.data}`, '_blank');
    },
    getServiceLabel() {
      this.repairId = this.repair.Id;
      this.labelShow = true;
    },
    handleDialogClose () {
      this.labelShow = false;
    },
    async getProforma () {
        const response = await this.$api.get(`/repairs/${this.repair.Id}/proforma`);
        window.open(`${this.$api.defaults.baseURL}/repairs/card/${response.data}`, '_blank');
    },
    async convertToQuote () {
        const response = await this.$api.get('/quotes/convert-from-repair', {params:{ repair_id: this.repair.Id }});
        this.$router.push('/quote/edit/'+response.data.sha);
    },
    rowClass (item) {
      return item.Status == 1 ? 'blue-grey lighten-4' : 'white darken-2';
    },
    //rowClass (item) {
      //if (item.Kind == 0) return 'white darken-2'
      //if (item.Kind == 1) return 'blue-grey lighten-5'
      //if (item.Kind == 2) return 'blue lighten-5'
      //item.Kind ? 'blue-grey lighten-5' : 'white darken-2';
      //return item.StockQty == 0 ? 'blue-grey lighten-4' : 'white darken-2';
      //return this.repairItems.indexOf(item) %2 ? 'blue-grey lighten-5' : 'white darken-2';
    //},
    async initialize () {
      this.loading = true
      this.getRepair();
      const techs = await this.$api.get("/repairs/technicians/");
      this.technicians = techs.data;
      
      const suppliersResp = await this.$api.get("/suppliers", { params: { limit: 2000 } });
      this.suppliers = suppliersResp.data;
      const resp = await this.$api.get("/inventory/items", {params: {limit: 4000}});

      this.allParts = resp.data;
      // this.getParts();

      var respHistParts = await this.$api.get("/repairs/vehicles/"+this.repair.VehId+"/items");
      this.histParts = respHistParts.data;
      // console.log(this.quote);
      // await this.fetchDigitalClientDetails();
      this.loading = false

    },
    prependPrefix(prefix) {
      // Define the possible prefixes
      const prefixes = ['#', '!', '@', '$'];

      // Check if orderSearch is defined and not empty
      if (this.searchParts) {
        // Remove existing prefix if present
        const firstChar = this.searchParts.charAt(0);
        if (prefixes.includes(firstChar)) {
          this.searchParts = this.searchParts.substring(1);
        }
      }

      // Prepend the new prefix
      this.searchParts = prefix + (this.searchParts || '');
    },
    fetchFilteredParts(queryText) {
      if (queryText==null) return;

      this.loading = true;

      // Determine the search mode based on the prefix
      const isSkuSearch = queryText.startsWith('#');
      const isRefSearch = queryText.startsWith('@');
      const isIdSearch = queryText.startsWith('!');
      let searchText = '';
      if (isRefSearch || isSkuSearch || isIdSearch) {
        searchText = queryText.slice(1).toUpperCase(); // Remove prefix for actual search
      } else {
        searchText = queryText.toUpperCase(); // To uppercase for search
      }

      // Convert '*' to a regex pattern for fuzzy matching
      const searchPattern = new RegExp('^' + searchText.replace(/[^\p{L}\p{N}\\*]/gu, '').replace(/\*/g, '.*') + '.*$', 'i');
      const searchSkuPattern = new RegExp('^.*\\.' + searchText.replace(/\*/g, '.*') + '$', 'i');
      // Split the search text into individual terms
      const searchTerms = searchText.split(/\s+/);

      // Simulate fetching data with filtering
      this.parts = this.allParts.filter(item => {
        const desc = item.Description.toUpperCase();
        const skus = item.FmSku.toUpperCase();
        const refs = item.References;

        // Fuzzy search for description
        // const descMatches = desc.includes(searchText) || searchPattern.test(desc);
        // Fuzzy search for description
        const descMatches = searchTerms.every(term => desc.includes(term));

        // Search in FmSku
        const skuMatches = searchSkuPattern.test(skus);

        // Search in References

        // const refMatches = refs.some(o => o.Sku.replace(/[^\p{L}\p{N}]/gu, '').includes(searchText));
        //const refMatches = refs.some(o => searchPattern.test(o.Sku.toUpperCase()));

        // Apply search logic based on the prefix
        // if (isSkuSearch) {
        //   return skuMatches || skus.includes(searchText);
        // } else if (isRefSearch) {
        //   return refMatches;
        // } else {
        //   return descMatches //|| skuMatches || refMatches;
        // }


        let matchReason = '';
        if (isSkuSearch) {
          if (skuMatches || skus.includes(searchText)) {
            matchReason = `Matched by SKU: ${searchText}`;
            item.matchReason = matchReason;
            return true;
          }
        } else if (isRefSearch) {
          const refMatches = refs.some(o => searchPattern.test(o.Sku.replace(/[^\p{L}\p{N}]/gu, '')));
          if (refMatches) {
            const matchedRef = refs.find(o => searchPattern.test(o.Sku.replace(/[^\p{L}\p{N}]/gu, '')));
            matchReason = `Matched by Reference: ${matchedRef ? matchedRef.Sku : ''}`;
            item.matchReason = matchReason;
            return true;
          }
        } else if (isIdSearch) {
            if (item.Id == searchText) {
              matchReason = `Matched by Id: ${searchText}`
              item.matchReason = matchReason;
              return true;
            }
        } else {
          if (descMatches) {
            matchReason = `Matched by Description: ${searchTerms.join(' ')}`;
            item.matchReason = matchReason;
            return true;
          }
        }

        return false;
      });
      this.loading = false;
    },
    async getParts() {
      const partsResp = await this.$api.get("/inventory/stock");
      this.parts = partsResp.data;
      this.parts = this.parts.sort((a, b) => {
      if (a.Id < b.Id) {
        return 1;
      }
      if (a.Id > b.Id) {
        return -1;
      }
      return 0;
      })
      this.fetchPartsFilter(this.orderSearch);
    },
    copyItem (item) {
      const addObj = Object.assign({}, item);
      addObj.itemId = this.repairItems.length + 1;
      this.repairItems.unshift(addObj);
    },
    editItem (item) {
      this.editedIndex = this.repairItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.parts = this.allParts.filter(part => part.Id == this.editedItem.PartId);
      this.dialog = true;
    },
    locateItem (item) {
      this.editedIndex = this.repairItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.openLocationDialog();
    },
    async deleteItem (item) {
      const index = this.repairItems.indexOf(item);
      if (confirm('Are you sure you want to delete this item?')) {
        if (item.Id) {
            const resp = await this.$api.delete("/inventory/preorders/"+item.Id);
          if (resp.status == 200) {
            this.repairItems.splice(index, 1);
          } else {
            alert(resp.data.detail);
          }
        } else {
              this.repairItems.splice(index, 1);
          }

      }
    },

    async getRepair() {

      const response = await this.$api.get("/repairs/" + this.$route.params.repairId, {cache: {maxAge: 30*1000}});
      this.repair = response.data;
      let j = 1;
      const preorders = await this.$api.get("/inventory/preorders/by-repair/" + this.$route.params.repairId, {cache: {maxAge: 30*1000}});
      this.repairItems = []
      for (var value of preorders.data) {
        console.log(value)
        value.itemId = j;
        this.repairItems.push(value);
        j +=1;
      }

    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300)
    },
    addNew() {
       const addObj = Object.assign({}, this.defaultItem);
       addObj.itemId = this.repairItems.length + 1;
       this.repairItems.unshift(addObj);
       this.editItem(addObj);
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    async savePart () {
        let checkout = {
            RepairId: this.repair.Id,
            TechId: this.partTechId,
            Qty: this.partQty,
            Status: this,
        }
        await this.$api.post("/inventory/preorder/create", checkout)
//        console.log(response);
        this.getRepair();
        this.getParts();
        this.fetchPartsFilter(null);

    },
    clearOrder(val) {
      if (val) this.partsFiltered = [];
      this.order = {StockQty: 0};
      this.orderSearch = '';
    },
    handleFocus(isFocused) {
      if (isFocused && !this.orderSearch) {
        this.showLatestItems();
      }
    },
    showLatestItems() {
      // Fetch the latest 20 items from the parts list
      this.partsFiltered = this.allParts.slice(20);
    },
    updateSearchInput(search) {
      if (search == null) {
        this.prefixIcon = 'mdi-tag'; // No icon if there's no input
        return
      }

      const inputValue = search.toString();
      if (inputValue.startsWith('#')) {
        this.prefixIcon = 'mdi-tag-text'; // Example icon for SKU
      } else if (inputValue.startsWith('@')) {
        this.prefixIcon = 'mdi-clipboard-list-outline'; // Example icon for matches
      } else if (inputValue.startsWith('!')) {
        this.prefixIcon = 'mdi-counter'; // Example icon for wildcard
      } else {
        this.prefixIcon = 'mdi-clipboard-text'; // Default icon or no icon
      }
    },

    validateCoQty (item) {
      if (item.StockQty > item.CoQty) {
        return true;
      }
      return false;
    },
    generateUniqueId() {
      return '_' + Math.random().toString(36).substr(2, 9);
    },
    fetchPartsFilter(queryText) {
      if (queryText == null || queryText == "") {
        // this.showLatestItems();
        this.partsFiltered = [];
        return false;
      }

      // Determine the search mode based on the prefix
      const isSkuSearch = queryText.startsWith('#');
      const isRefSearch = queryText.startsWith('@');
      const isIdSearch = queryText.startsWith('!');
      let searchText = '';
      if (isRefSearch || isSkuSearch || isIdSearch) {
        searchText = queryText.slice(1).toUpperCase(); // Remove prefix for actual search
      } else {
        searchText = queryText.toUpperCase(); // To uppercase for search
      }

      // Convert '*' to a regex pattern for fuzzy matching
      const searchPattern = new RegExp('^' + searchText.replace(/[^\p{L}\p{N}\\*]/gu, '').replace(/\*/g, '.*') + '.*$', 'i');
      const searchFmSkuPattern = new RegExp('^.*\\.' + searchText.replace(/\*/g, '.*') + '$', 'i');
      const searchSkuPattern = new RegExp('^.*' + searchText.replace(/\*/g, '.*') + '.*$', 'i');
      // Split the search text into individual terms
      const searchTerms = searchText.split(/\s+/);

      // Filter the parts array
      this.partsFiltered = this.parts.filter(item => {
        const desc = item.Description.toUpperCase();
        const remarks = item.Remarks || "";
        const supSku = item.SupplierSku.toUpperCase();
        const manfSku = item.ManufacturerSku.toUpperCase();
        const FmSku = item.FmSku.toUpperCase();
        const order = item.Id;
        const partId = item.PartId;

        // Fuzzy search for description
        const descMatches = searchTerms.every(term => desc.includes(term));
        const remarksMatches = searchTerms.some(term => remarks.includes(term));

        // Search in FmSku
        const skuMatches = searchFmSkuPattern.test(FmSku);

        // Apply search logic based on the prefix
        if (isSkuSearch) {
          return skuMatches || searchSkuPattern.test(supSku) || searchSkuPattern.test(manfSku);
        } else if (isRefSearch) {
          // Assuming `item.References` is available and similar to `fetchFilteredParts`
          const refs = item.References || [];
          return refs.some(o => searchPattern.test(o.Sku.replace(/[^\p{L}\p{N}]/gu, '')));
        } else if (isIdSearch) {
          return order == searchText || partId == searchText;
        } else {
          return descMatches || remarksMatches;
        }
      });
    },
    customFilter(item, queryText) {
      if (queryText == null) {
        this.partsFiltered = [];
        return false;
      }
      // Determine the search mode based on the prefix
      const isSkuSearch = queryText.startsWith('#');
      const isRefSearch = queryText.startsWith('@');
      const isIdSearch = queryText.startsWith('!');
      let searchText = '';
      if (isRefSearch || isSkuSearch || isIdSearch) {
        searchText = queryText.slice(1).toUpperCase(); // Remove prefix for actual search
      } else {
        searchText = queryText.toUpperCase(); // To uppercase for search
      }

      // Convert '*' to a regex pattern for fuzzy matching
      const searchPattern = new RegExp('^' + searchText.replace(/[^\p{L}\p{N}\\*]/gu, '').replace(/\*/g, '.*') + '.*$', 'i');
      const searchFmSkuPattern = new RegExp('^.*\\.' + searchText.replace(/\*/g, '.*') + '$', 'i');
      const searchSkuPattern = new RegExp('^.*' + searchText.replace(/\*/g, '.*') + '.*$', 'i');
      // Split the search text into individual terms
      const searchTerms = searchText.split(/\s+/);

      const desc = item.Description.toUpperCase();
      const supSku = item.SupplierSku.toUpperCase();
      const manfSku = item.ManufacturerSku.toUpperCase();
      const FmSku = item.FmSku.toUpperCase();
      const order = item.Id;
      const partId = item.PartId;

      // Fuzzy search for description
      const descMatches = searchTerms.every(term => desc.includes(term));

      // Search in FmSku
      const skuMatches = searchFmSkuPattern.test(FmSku);

      // Apply search logic based on the prefix
      if (isSkuSearch) {
        return skuMatches || searchSkuPattern.test(supSku) || searchSkuPattern.test(manfSku);
      } else if (isRefSearch) {
        // Assuming `item.References` is available and similar to `fetchFilteredParts`
        const refs = item.References || [];
        return refs.some(o => searchPattern.test(o.Sku.replace(/[^\p{L}\p{N}]/gu, '')));
      } else if (isIdSearch) {
        return order == searchText || partId == searchText;
      } else {
        return descMatches
      }
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.repairItems[this.editedIndex], this.editedItem);
        this.patchRepairItem(this.editedIndex);
      } else{
        this.repairItems.push(this.editedItem);
        this.patchRepairItem(-1);
      }
      this.close()
    },
    async patchRepairItem(itemIndex) {
      let item = this.repairItems.at(itemIndex);
      item.RepairId = this.$route.params.repairId
      item.VehicleId = this.repair.VehId
      if (item.Id) {
        const response = await this.$api.patch("/inventory/preorders/"+item.Id, item)
          //console.log(response);
          item.Sku = response.data.Sku;
          item.Description = response.data.Description;

      } else {
        const response = await this.$api.post("/inventory/preorders/create", item)
          console.log(response);
        //item = response.data;

      }
      await this.getRepair();
    },
    itemSelected(selected) {
      if (selected.value) {
        this.selectedRows.push(selected.item)
      } else {
        const index = this.selectedRows.indexOf(selected.item.Id);
          
        this.selectedRows.splice(index, 1)
      }
    },
    itemSelectAll(selected) {
      if (selected.value) {
        this.selectedRows = []
        console.log(selected)
        for (let item in selected.items) {
          if (selected.items[item].Status == 0) this.selectedRows.push(selected.items[item])
        }
      } else {
        this.selectedRows = []
      }
    },

    async checkoutReceivedPreorders() {
      if (this.processingCheckout) return;
      this.processingCheckout = true;
      const eligible = (list) => (list || []).filter(po => po.Status === 0 && po.CheckinId);
      const base = this.selectedRows && this.selectedRows.length ? this.selectedRows : this.repairItems;
      const items = eligible(base);
      //const items = (this.repairItems || []).filter(po => po.Status === 0 && po.CheckinId);
      let ok = 0, fail = 0;
      for (const po of items) {
        const payload = {
          OrderId: po.CheckinId,
          TechId: po.TechId || 1,
          Qty: po.Qty || 1,
          Price: po.Price,
          RepairId: po.RepairId || this.repair.Id,
        };
        try {
          await this.$api.post('/inventory/parts/checkout', payload);
          await this.$api.patch(`/inventory/preorders/${po.Id}`, { Status: 1 });
          ok++;
        } catch (e) {
          console.error('Checkout failed for preorder', po.Id, e);
          fail++;
        }
      }
      this.snackText = `Χρεώθηκαν: ${ok}, Απέτυχαν: ${fail}`;
      this.snackbar = true;
      this.selectedRows = [];
      await this.getRepair();
      this.processingCheckout = false;
    },
    onCsvPick() {
      if (this.csvProcessing) return;
      this.$refs.csvInput && this.$refs.csvInput.click();
    },

    async onCsvSelected(e) {
      const file = e.target.files && e.target.files[0];
      e.target.value = '';
      if (!file) return;

      try {
        this.csvProcessing = true;
        const text = await file.text();
        const matrix = this.parseCsv(text);
        if (!matrix.length) {
          this.snackText = 'Το αρχείο CSV δεν περιέχει δεδομένα.';
          this.snackbar = true;
          return;
        }
        // Header row (Greek headers)
        const header = matrix[0].map(h => h.trim());
        const rows = [];
        for (let i = 1; i < matrix.length; i++) {
          const raw = matrix[i];
          if (!raw || raw.length === 0) continue;
          // Skip empty line
          if (raw.length === 1 && (raw[0] || '').trim() === '') continue;

          const entry = {};
          header.forEach((h, idx) => {
            entry[h] = raw[idx] != null ? String(raw[idx]).trim() : '';
          });

          // Map to internal payload shape
          const mapped = this.mapGreekCsvToPayload(entry);
          // attach row id for v-data-table selection stability
          mapped.__rowId = `${i}-${Math.random().toString(36).slice(2,7)}`;
          rows.push(mapped);
        }

        if (!rows.length) {
          this.snackText = 'Δεν εντοπίστηκαν έγκυρες γραμμές.';
          this.snackbar = true;
          return;
        }

        this.csvRows = rows;
        this.csvSelected = [...rows]; // preselect all
        this.csvPreviewDialog = true;
      } catch (err) {
        console.error(err);
        this.snackText = 'Απέτυχε η επεξεργασία του αρχείου CSV.';
        this.snackbar = true;
      } finally {
        this.csvProcessing = false;
      }
    },

    parseCsv(text) {
      // Basic CSV parser handling quotes and commas, respects CRLF
      const lines = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
      const out = [];
      for (const line of lines) {
        // Keep empty field info if needed, skip fully empty lines later
        if (line === undefined || line === null) continue;
        let cur = '';
        let inQuotes = false;
        const row = [];
        for (let i = 0; i < line.length; i++) {
          const ch = line[i];
          if (ch === '"') {
            if (inQuotes && i + 1 < line.length && line[i + 1] === '"') {
              cur += '"';
              i++;
            } else {
              inQuotes = !inQuotes;
            }
          } else if (ch === ',' && !inQuotes) {
            row.push(cur);
            cur = '';
          } else {
            cur += ch;
          }
        }
        row.push(cur);
        out.push(row);
      }
      return out;
    },

    mapGreekCsvToPayload(row) {
      // Helpers
      const toNum = (v, def = 0) => {
        if (v === undefined || v === null || v === '') return def;
        // Replace comma decimal, remove quotes and spaces
        const s = String(v).replace(/\./g, '').replace(',', '.'); // InterCars uses dot as thousand sep, comma as decimal
        const n = Number(s);
        return Number.isFinite(n) ? n : def;
      };
      const toInt = (v, def = 0) => {
        const n = parseInt(String(v).replace(/[^\d-]/g, ''), 10);
        return Number.isFinite(n) ? n : def;
      };

      // Map Greek headers to internal fields
      const payload = {
        ManufacturerSku: row['InterCars Αρ. Αναφοράς'] || null,
        Qty: toNum(row['Ποσότητα'], 1),
        SupplierSku: row['Κωδικός προϊόντος'] || null,
        Remarks: row['Όνομα'] || '',
        Manufacturer: row['Κατασκευαστής'] || null,
        Price: toNum(row['Λιανική τιμή ανά τεμάχιο'], 0),
        NetPrice: toNum(row['Χονδρική τιμή ανά τεμάχιο'], 0),
        // Optional columns if your source ever contains
        PartId: toInt(row['PartId'] || row['Κωδικός Ανταλλακτικού'], 0) || undefined,

        // Defaults / context
        Unit: 'ΤΕΜ',
        Status: -1,
        TechId: 1,
        RepairId: this.repair?.Id || this.$route.params.repairId,
        VehicleId: this.repair?.VehId,
        SupplierId: 3, // InterCars
      };

      if (!payload.Qty || payload.Qty <= 0) {
        throw new Error('Μη έγκυρη ποσότητα (Qty).');
      }
      return payload;
    },

    closeCsvPreview() {
      this.csvPreviewDialog = false;
      this.csvRows = [];
      this.csvSelected = [];
    },

    openCsvEdit(item) {
      this.csvEditItem = { ...item };
      this.csvEditDialog = true;
    },

    applyCsvEdit() {
      if (!this.csvEditItem) return;
      const idx = this.csvRows.findIndex(r => r.__rowId === this.csvEditItem.__rowId);
      if (idx !== -1) {
        // Keep selection consistent: update item in both csvRows and csvSelected if present
        this.$set(this.csvRows, idx, { ...this.csvEditItem });
        const selIdx = this.csvSelected.findIndex(r => r.__rowId === this.csvEditItem.__rowId);
        if (selIdx !== -1) {
          this.$set(this.csvSelected, selIdx, { ...this.csvEditItem });
        }
      }
      this.csvEditDialog = false;
    },

    async submitSelectedCsv() {
      if (!this.csvSelected.length) return;
      this.csvProcessing = true;
      let ok = 0, fail = 0;

      for (const it of this.csvSelected) {
        const payload = this.csvRowToApiPayload(it);
        try {
          await this.$api.post('/inventory/preorders/create', payload);
          ok++;
        } catch (e) {
          console.error('Create preorder failed', payload, e);
          fail++;
        }
      }

      this.snackText = `Αποτέλεσμα εισαγωγής: Επιτυχή ${ok}, Απέτυχαν ${fail}`;
      this.snackbar = true;

      this.csvProcessing = false;
      this.closeCsvPreview();
      await this.getRepair();
    },

    csvRowToApiPayload(row) {
      // Ensure fields expected by API. Reuse what we have, only keep known keys.
      return {
        RepairId: row.RepairId || this.repair?.Id || this.$route.params.repairId,
        VehicleId: row.VehicleId || this.repair?.VehId,
        PartId: row.PartId || undefined,
        SupplierSku: row.SupplierSku || null,
        ManufacturerSku: row.ManufacturerSku || null,
        Manufacturer: row.Manufacturer || null,
        Remarks: row.Remarks || '',
        Qty: row.Qty || 1,
        Unit: row.Unit || 'ΤΕΜ',
        Price: row.Price || 0,
        SupplierId: row.SupplierId || 3,
        Status: row.Status != null ? row.Status : -2,
        TechId: row.TechId || 1,
      };
    },
    async copyHistPartToPreorder(item) {
      try {
        let supplierId = null;
        let supplierSku = null;
        // If this history row is tied to a stock checkout, resolve the supplier from that lot
        if (item && item.CheckoutPart) {
          try {
            const res = await this.$api.get(`/inventory/parts/checkin-info/${item.CheckoutPart}`);
            if (res && res.data) {
                 supplierId = res.data.SupplierId || null;
                 supplierSku = res.data.SupplierSku || null;
            }
          } catch (err) {
            console.warn('Failed to fetch checkout info for SupplierId', item.CheckoutPart, err);
          }
        }

        const payload = {
          // Context
          RepairId: this.repair?.Id || this.$route.params.repairId,
          VehicleId: this.repair?.VehId,
          // Attempt to keep the part link if we have it
          PartId: item.PartId || null,
          // Map best-effort fields from hist parts
          SupplierSku: supplierSku || null,
          ManufacturerSku: item.ManfSku || item.ManufacturerSku || null,
          Manufacturer: item.Manf || item.Manufacturer || null,
          Description: item.Description || null, // server may ignore, but harmless
          Remarks: item.Remarks || item.Description || '',
          Qty: item.Qty || 1,
          Unit: item.Unit || 'ΤΕΜ',
          Price: item.Price || 0,
          SupplierId: supplierId,
          Status: -2, // Request
          TechId: (item.Technician && item.Technician.Id) || item.TechId || 1,
        };

        // Post to create preorder
        await this.$api.post('/inventory/preorders/create', payload);

        this.snackText = 'Δημιουργήθηκε προπαραγγελία από το ιστορικό.';
        this.snackbar = true;

        // Refresh current repair list
        await this.getRepair();
      } catch (e) {
        console.error('Failed to copy hist part to preorder', e);
        this.snackText = 'Αποτυχία δημιουργίας προπαραγγελίας.';
        this.snackbar = true;
      }
    },
  },
  }
</script>

<style>
.row-odd {
  background-color: orange;
}
.row-even {
  background-color: "red";
}
.checkout-error {
  background-color: orange;
}

.selected-invoice {
  background-color: #e3f2fd !important; /* Light blue, adjust as needed */
}

.correlated-invoice {
  background-color: #c8e6c9 !important; /* Light green for already correlated */
  pointer-events: none;
  opacity: 0.7;
}

/* .v-overlay--active {
    backdrop-filter: blur(4px);
    background: rgb(0 0 0 / 0.6);
} */

</style>
